import { validateNumber } from 'ember-changeset-validations/validators';
import type { TCustomColumn } from 'volta/utils/column-utils';

export const CAMEL_CASE_REGEX = /^[a-z]+([A-Z][a-z]+)*$/;
export type ICustomColumnErrors = { index: number; message: string }[];
const checkCustomColumns = () => {
  return (_: string, columns: TCustomColumn[]) => {
    const checks: ICustomColumnErrors = [];

    if (columns?.length) {
      columns.forEach((c: TCustomColumn, index: number) => {
        if (!c.label || !c.path || !c.type) {
          checks.push({ index, message: 'empty' });
        }
        if (!CAMEL_CASE_REGEX.test(c.path)) {
          checks.push({ index, message: 'invalid' });
        }
      });
    }

    return checks.length === 0 || checks;
  };
};

export default {
  execution: {
    customColumns: [checkCustomColumns()],
    projectionDltCount: [validateNumber({ positive: true, allowBlank: true })]
  },
  poWorkbench: {
    projectionMonths: [validateNumber({ gte: 1, lte:36 })]
  }
};
